export default "__VITE_ASSET__Dk2IPd1___"